/**
 * Textos de Compres (`ca`): tall «estats» de les millores de Compres (OBR-190 / OBR-181 / OBR-117). Tall propi: no es toca `ca.ts`.
 * Les tres llengües han de tenir les mateixes claus (i18n.test.ts); cap text literal a les vistes.
 *
 * OBR-190, estat «Pendent d'enviar» de la comanda de compra: les etiquetes de l'estat viuen a
 * `backoffice.purchaseOrderStatus` (a `ca.ts`); aquí hi ha els textos NOUS que l'acompanyen.
 */

export const estatsCa = {
  'backoffice.purchaseOrderDispatch': {
    // Motiu pel qual «Registra la recepció» és inhabilitat mentre la comanda no s'ha enviat (text acordat al ticket).
    receptionBlockedHint:
      'Encara no has enviat aquesta comanda al proveïdor. Envia-la o marca-la com a enviada abans de registrar-ne la recepció.',
    // Avís d'un esborrany: confirmar-lo ja no el fa visible a l'App, cal enviar-lo.
    draftNotVisibleToPlanta:
      'Aquesta comanda encara és un esborrany i no surt a la recepció de l’app de planta. Confirma-la i envia-la al proveïdor perquè l’operari la pugui rebre.',
    // Avís d'una comanda confirmada i no enviada.
    pendingNotVisibleToPlanta:
      'Aquesta comanda està confirmada però encara no s’ha enviat al proveïdor, i per això no surt a la recepció de l’app de planta ni es pot recepcionar. Envia-la o marca-la com a enviada.',
    // El formulari d'edició d'una comanda que ja no és un esborrany (enllaç directe: el detall n'amaga el botó).
    notEditable:
      'Aquesta comanda ja no es pot editar: només es poden canviar les comandes en curs (esborranys).',
    // «Finalitza» massiu sobre comandes pendents d'enviar (se salten: no hi ha res a esperar).
    skip_not_sent_one: '{{count}} encara no s’ha enviat al proveïdor (si ja no cal, es cancel·la)',
    skip_not_sent_other: '{{count}} encara no s’han enviat al proveïdor (si ja no cal, es cancel·len)',
  },
} as const;
